import { localStorageManager } from '@libs/shared';
import { LOCAL_STORAGE_MIGRATE } from '~/constants';

/**
 * 切换语言
 *
 * @param language
 */
export const switchLanguage = (language: string) => {
    if (language !== localStorageManager.get(LOCAL_STORAGE_MIGRATE.LANG)) {
        localStorageManager.set(LOCAL_STORAGE_MIGRATE.LANG, language);
    }
};
